import { Injectable } from '@angular/core';
import {HttpClient, HttpEvent, HttpErrorResponse, HttpEventType} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from "../../environments/environment";
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })


export class ClienteService {


    backendUrl: string = environment.apiUrl;
    url_final: string;


    constructor(private http: HttpClient) {
    }

    guardarCliente(datos_envio){
      this.url_final = this.backendUrl + "/rmsfe/guardar_cliente_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {datos_envio})
      .pipe(map(response => {
        return response;
      }));
    }

    consultarCliente(seller_customer_id){
      this.url_final = this.backendUrl + "/rmsfe/get_cliente_api?seller_customer_id="
      this.url_final = `${this.url_final}${seller_customer_id}`;
      return this.http.get<any>(this.url_final,  {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    eliminarCliente(seller_customer_id){
      this.url_final = this.backendUrl + "/rmsfe/eliminar_cliente_api"
      this.url_final = `${this.url_final}`;

      var fd = new FormData();
      fd.append('seller_customer_id', seller_customer_id);

      return this.http.post<any>(this.url_final, fd)
      .pipe(map(response => {
        return response;
      }));

    }

    actualizarCliente(datos_envio){
      this.url_final = this.backendUrl + "/rmsfe/actualizar_cliente_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {datos_envio})
      .pipe(map(response => {
        return response;
      }));
    }

    //Funciones para modulo de cajas
    guardarCaja(datos_envio){
      this.url_final = this.backendUrl + "/rmsfe/guardar_caja_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {datos_envio})
      .pipe(map(response => {
        return response;
      }));
    }

    consultarCaja(box_id){
      this.url_final = this.backendUrl + "/rmsfe/get_caja_api?box_id="
      this.url_final = `${this.url_final}${box_id}`;
      return this.http.get<any>(this.url_final,  {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    eliminarCaja(box_id){
      this.url_final = this.backendUrl + "/rmsfe/eliminar_caja_api"
      this.url_final = `${this.url_final}`;

      var fd = new FormData();
      fd.append('box_id', box_id);

      return this.http.post<any>(this.url_final, fd)
      .pipe(map(response => {
        return response;
      }));

    }

    actualizarCaja(datos_envio){
      this.url_final = this.backendUrl + "/rmsfe/actualizar_caja_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {datos_envio})
      .pipe(map(response => {
        return response;
      }));
    }


}
